import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
    ActivatedRoute,
    NavigationEnd,
    ParamMap,
    Router,
} from "@angular/router";
import { Location } from "@angular/common";
import { Subject, Subscription, forkJoin } from "rxjs";
import { AppService } from "src/app/app.service";
import { EmitterService } from "src/app/EmitterService";
import { filter, takeUntil } from "rxjs/operators";
import { NavbarStyleThreeComponent } from "../../layouts/navbar-style-three/navbar-style-three.component";

@Component({
    selector: "app-template-page",
    templateUrl: "./template-page.component.html",
    styleUrls: ["./template-page.component.scss"],
})
export class TemplatePageComponent implements OnInit, OnDestroy {
    imageLoaded = false;
    fetchinData = true;
    subscription: Subscription;
    mainData: any;
    currentRoute: string;
    currentMenuItem: any;
    ContentData: any;
    currentContentData: any;
    private ngUnsubscribe = new Subject();
    @ViewChild(NavbarStyleThreeComponent)
    childComponent: NavbarStyleThreeComponent;

    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private appService: AppService,
        private router: Router,
        private emitterService: EmitterService
    ) { }

    ngOnInit() {
        this.subscription = this.emitterService.currentMessage.subscribe(
            (message) => {
                if (message === true) {
                    // this.emitterService.changeMessage(false);
                    this.FetchData();
                }
            }
        );

        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            takeUntil(this.ngUnsubscribe)
        ).subscribe(() => {
            this.FetchData();
        });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
        this.subscription.unsubscribe();
        // if (this.subscription)
        // {
        //   this.subscription.unsubscribe();
        // }
    }

    FetchData() {
        this.fetchinData = true;
        this.currentContentData = null;
        this.currentMenuItem = null;

        forkJoin([this.appService.getContents()])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((response: any) => {
                console.log(response, "response FetchData");

                this.ContentData = response[0]?.data || [];
                this.currentRoute = "/" + this.route.snapshot.url.join("/");

                const normalize = (str: any) => (str || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');
                const routeNorm = normalize(this.currentRoute);

                const isMatch = (name: string, route: string): boolean => {
                    const n = normalize(name);
                    const r = normalize(route);
                    if (!n || !r) return false;
                    if (n === r) return true;
                    if (n === `scienceclub${r}` || `scienceclub${n}` === r) return true;

                    const nClean = n.replace(/activities|activity|club/g, '');
                    const rClean = r.replace(/activities|activity|club/g, '');
                    if (nClean && rClean && nClean === rClean) return true;

                    return false;
                };

                // 1. Prioritize direct match from ContentData by ContentCategoryName or TitleEn against currentRoute
                let matchedContent = null;
                const directMatches = this.ContentData.filter((x: any) => {
                    return isMatch(x.ContentCategoryName, this.currentRoute) || isMatch(x.TitleEn, this.currentRoute);
                });

                if (directMatches.length > 0) {
                    matchedContent = directMatches[0];
                }

                // 2. Lookup or sync with SiteMapList from localStorage
                let mData = localStorage.getItem("mainData");
                if (mData != null) {
                    try {
                        this.mainData = JSON.parse(mData);
                        const findMenuItem = (items: any[], predicate: (item: any) => boolean): any => {
                            if (!items || !items.length) return null;
                            for (const item of items) {
                                if (predicate(item)) return item;
                                if (item.Items && item.Items.length > 0) {
                                    const found = findMenuItem(item.Items, predicate);
                                    if (found) return found;
                                }
                            }
                            return null;
                        };

                        let matchedItem = findMenuItem(this.mainData?.SiteMapList, (item) => item.MenuUrl && item.MenuUrl === this.currentRoute);
                        if (!matchedItem) {
                            matchedItem = findMenuItem(this.mainData?.SiteMapList, (item) => item.MenuUrl && isMatch(item.MenuUrl, this.currentRoute));
                        }
                        if (!matchedItem) {
                            matchedItem = findMenuItem(this.mainData?.SiteMapList, (item) => {
                                if (!item.MenuName && !item.DisplayName) return false;
                                return isMatch(item.MenuName, this.currentRoute) || isMatch(item.DisplayName, this.currentRoute);
                            });
                        }

                        if (matchedItem) {
                            this.currentMenuItem = matchedItem;
                            if (!matchedContent && (matchedItem.MenuCode || matchedItem.ContentCategoryId)) {
                                const targetCode = matchedItem.MenuCode || matchedItem.ContentCategoryId;
                                const codeMatches = this.ContentData.filter(
                                    (x: any) => (x.ContentCategoryId && x.ContentCategoryId == targetCode) || (x.MenuCode && x.MenuCode == targetCode)
                                );
                                if (codeMatches.length > 0) {
                                    if (isMatch(codeMatches[0].ContentCategoryName, this.currentRoute) ||
                                        isMatch(codeMatches[0].TitleEn, this.currentRoute) ||
                                        isMatch(codeMatches[0].ContentCategoryName, matchedItem.MenuName || '')) {
                                        matchedContent = codeMatches[0];
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        console.error("Error parsing mainData from localStorage", e);
                    }
                }

                this.currentContentData = matchedContent;

                // Fallback for currentMenuItem if not found in sitemap but content exists
                if (!this.currentMenuItem && this.currentContentData) {
                    this.currentMenuItem = {
                        MenuName: this.currentContentData.ContentCategoryName || this.currentContentData.TitleEn,
                        DisplayName: this.currentContentData.TitleEn || this.currentContentData.ContentCategoryName,
                        MenuCode: this.currentContentData.ContentCategoryId
                    };
                }

                console.log(
                    this.currentContentData,
                    "this.currentContentData.........."
                );
                this.emitterService.changeMessage(false);
                this.fetchinData = false;
            }, (error) => {
                this.fetchinData = false;
                this.currentContentData = null;
            });
    }

    onImageLoad() {
        this.imageLoaded = true;
    }
}
